// @flow
import * as React from 'react';
import { useContext, useState } from 'react';
import { useCallHistoryByAirCallIdQuery } from '../../../shared';
import { CallAiAnalysisDrawer } from '../../client/ui/calls/ui/call-ai-analysis-drawer';

interface ContextProps {
  open: (airCallId: number | string) => void;
}

const CallDrawerContext = React.createContext<ContextProps>({ open: () => {} });

// Lets any QA row (Recent calls, Audits, By Client) open the full call drawer on the QA tab
// by airCallId - it fetches the call via callHistoryByAirCallId, same shape as the client page.
export const useCallDrawer = () => useContext(CallDrawerContext);

export function withCallDrawer<P>(Wrapped: React.FC<P>) {
  return (props: P) => {
    const [airCallId, setAirCallId] = useState<number | string | null>(null);

    const { data } = useCallHistoryByAirCallIdQuery({
      variables: { airCallId },
      skip: airCallId == null,
    });

    const call = data?.callHistoryByAirCallId || undefined;

    return (
      <CallDrawerContext.Provider value={{ open: id => setAirCallId(id) }}>
        <CallAiAnalysisDrawer call={call} open={airCallId != null} onClose={() => setAirCallId(null)} />
        <Wrapped {...props} />
      </CallDrawerContext.Provider>
    );
  };
}